import type { QueryFunctionContext } from '@tanstack/react-query';
import { SubscriptionsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { subscriptionsKeys } from 'app/queries/subscriptions/subscriptionsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof subscriptionsKeys.memberDetail>>;

export const createFetchSubscriptionQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId, subscriptionId }], signal }: TParams) =>
    call(() => cancelOnSignal(SubscriptionsService.findOne({ baId, subscriptionId }), signal));
